import modSchemaMixin from "@/mixins/sheet/base/modSchemaMixin.js";
import sheetInterfaceMixin from "@/mixins/sheet/base/sheetInterfaceMixin.js";
import searchBtnMixin from "@/mixins/sheet/operation/searchBtnMixin.js";
import updateBtnMixin from "@/mixins/sheet/operation/updateBtnMixin.js";
import batchUpdateBtnMixin from "@/mixins/sheet/operation/batchUpdateBtnMixin.js";
import batchExportBtnMixin from "@/mixins/sheet/operation/batchExportBtnMixin.js";
import customBtnMixin from "@/mixins/custom/operation/customBtnMixin.js";
import sheetSelectRenderMixin from "@/mixins/sheet/sheetSelectRenderMixin.js";

export default {
    mixins: [
        modSchemaMixin,
        sheetInterfaceMixin,
        searchBtnMixin,
        updateBtnMixin,
        batchUpdateBtnMixin,
        batchExportBtnMixin,
        customBtnMixin,
        sheetSelectRenderMixin
    ],
    components: {},
    inject: ["companyId", "appId", "appObj"],
    props: {},
    data () {
        return {
            showBox: false,
            listData: [],
            selectIds: [],
            selections: [],
            checkAll: false,

            // 排序对象
            sortObj: {
                sortType: "",
                field: undefined
            },

            // 分页
            total: 0,
            pagePropsObj: {
                page: 1,
                pagesize: 10
            }
        };
    },
    computed: {
        urlParams () {
            return {
                module: "sheet",
                name: "index"
            };
        },
        layout () {
            return this.appObj ? this.appObj.layout : "creative";
        },
        allColumns () {
            return this.$transformToColumns(this.curScreenFormList, this.tableType === "singleData");
        },
        columns () {
            return this.$transformToColumns(this.curScreenShowFormList);
        },
        lessColumns () {
            return this.columns.slice(0, 5);
        },
        sortData () {
            let sortField = this.curScreen && this.curScreen.sortField && this.curScreen.sortField.length ? this.curScreen.sortField.join(" ") + " " : "";
            return sortField + `${
                this.sortObj.sortType && `${this.sortObj.sortType === "asc" ? "" : "-"}${this.sortObj.field}`
            } -createdAt`;
        }
    },
    created () {},
    methods: {
        // 接口 -获取列表数据
        getListData (callback) {
            this.$https({
                url: {
                    ...this.urlParams,
                    name: this.tableType === "panel" ? "groupIndex" : "index"
                },
                params: {
                    search: {
                        conditions: this.searchConditions
                    },
                    ...this.indexParams,
                    screenKey: this.screenKey,
                    groupField: this.groupField, // groupField暂时不在本mixin
                    fulltextSearch: this.fulltextSearch || (this.searchObj ? this.searchObj.fulltextSearch : ""), // sheetModal内使用的是searchObj
                    advSearch: this.searchParams,
                    fields: this.curScreenShowFields,
                    sort: this.sortData,
                    pagination: {
                        page: this.pagePropsObj.page,
                        pagesize: this.pagePropsObj.pagesize
                    }
                },
                callback: data => {
                    this.showBox = true;
                    if (this.tableType === "panel") {
                        this.listData = data.list.map(item =>
                            ({
                                ...item,
                                loading: false,
                                finished: item.total <= item.list.length
                            })
                        );
                    } else {
                        this.listData = data.list;
                        this.total = data.total || 0;
                    }

                    callback && callback.call(this);
                }
            });
        },

        // 重置
        reset (callback) {
            this.checkAll = false;
            this.selectIds = [];
            this.selections = [];

            this.showBox = false;
            this.getListData(callback);
        },
        // 搜索
        search () {
            this.pagePropsObj.page = 1;
            this.reset();
        },
        // 切换分页
        changePage (page) {
            this.pagePropsObj.page = page;
            this.reset();
        },
        // 切换分页条数
        changePageSize (pagesize) {
            this.pagePropsObj.page = 1;
            this.pagePropsObj.pagesize = pagesize;
            this.reset();
        },

        // 改变排序
        changeSort (sortObj) {
            this.sortObj = sortObj;
            this.search();
        },
        // 回调 -列表选择项改变
        changeSelect (selectIds, selections) {
            this.selectIds = selectIds;
            this.selections = selections;
        },
        // // 回调 -列表某行选择项改变
        // select (selectIds, selections, bool) {
        //     this.selectIds = selectIds;
        //     this.selections = selections;
        // },
        // // 回调 -列表全选改变
        // selectAll (selectIds, selections, row, bool) {
        //     this.selectIds = selectIds;
        //     this.selections = selections;
        // },

        // 点击删除
        clickDelete (operationItem, dataItem) {
            this.handleBatchDelete([dataItem._id]);
        },
        // 点击批量删除
        clickBatchDelete (operationItem) {
            this.handleBatchDelete();
        },
        // 删除
        deleteCb (datas) {
            if (["panel"].includes(this.tableType)) {
                datas.list.forEach(dataItem => {
                    this.listData.some(groupItem => {
                        const findIndex = groupItem.list.findIndex(item => item._id === dataItem._id);
                        if (findIndex > -1) {
                            groupItem.list.splice(findIndex, 1);
                            groupItem.total--;
                            return true;
                        } else {
                            return false;
                        }
                    });
                });
            } else {
                this.getListData();
            }
        }
    }
};



// WEBPACK FOOTER //
// ./src/mixins/sheet/sheetMixin.js